var map = {
	"./arrow.svg": 6383,
	"./banner.svg": 4880,
	"./banners.svg": 2767,
	"./binding.svg": 905,
	"./black_white_color.svg": 8277,
	"./brand_identity.svg": 2300,
	"./canvas.svg": 1117,
	"./chevron.svg": 6162,
	"./clips.svg": 3413,
	"./custom_design.svg": 3379,
	"./customer.svg": 1141,
	"./design.svg": 8002,
	"./facebook.svg": 150,
	"./instagram.svg": 4121,
	"./linkedin.svg": 5933,
	"./occasional_printing.svg": 4174,
	"./outdoor_advertising.svg": 1687,
	"./photo-on-poster-and-on-dibond-privately.svg": 3097,
	"./pinterest.svg": 1932,
	"./plan_print.svg": 4130,
	"./posters_machines.svg": 8890,
	"./presentation_material.svg": 1839,
	"./print-on-dibond-companies.svg": 747,
	"./promo_material.svg": 427,
	"./quality.svg": 2902,
	"./quote.svg": 8722,
	"./service.svg": 3185,
	"./sticker.svg": 8099,
	"./thesis.svg": 3001,
	"./twitter.svg": 1365,
	"./wave.svg": 6581,
	"./webatvantage.svg": 1613,
	"./wind-banners-beach-flags.svg": 2863,
	"./x.svg": 2643,
	"./yard-cloths.svg": 1729,
	"./youtube.svg": 4401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4683;